import React from 'react';
import style from './init-error.module.scss';
import useApp from 'hooks/useApp';
import useInitialiseApp from 'hooks/useInitialiseApp';
import { DEFAULT_LANGUAGE, translations } from 'translations';

const Error: React.FC = () => {

    const initialise = useInitialiseApp();

    const { language, error } = useApp();

    const networkConnection = translations.networkConnection;
    const tryAgainLoading = networkConnection?.[language]?.tryAgainLoading ?? networkConnection?.[DEFAULT_LANGUAGE]?.tryAgainLoading;
    const tryAgainButton = networkConnection?.[language]?.tryAgainButton ?? networkConnection?.[DEFAULT_LANGUAGE]?.tryAgainButton;

    return (
        <div className={style.initErrorContainer}>
            <div className={style.initErrorContent}>
                <p>{error}</p>
                <p>{tryAgainLoading}</p>
                <button onClick={initialise}>
                    {tryAgainButton}
                </button>
            </div>
        </div>
    )
}

export default Error;